module.exports = __webpack_public_path__ + "static/media/bnr10.b4929d9d.jpg";